// Web Crypto is available on every target, but the model is written without assuming the DOM
// lib, so declare the one member we use (the same way `@hq/core` does).
declare const crypto: { randomUUID(): string };

export type NewId = () => string;

/** Default id generator for new panes, groups, and splits. */
export function newId(): string {
  return crypto.randomUUID();
}
